import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import SalesReportListPageUI from './SalesReportListPageUI';

class SalesReportListPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      salesReportList: null,
    };
  }

  render() {
    return (
      <SalesReportListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        salesReportList={this.state.salesReportList}
        onRefreshClick={this.onRefreshClick}
      />
    );
  }

  componentDidMount() {
    const { context } = this.props;
    this.getSalesReportList(context);
  }

  getSalesReportList(context) {
    const cacheManager = new CacheManager({
      resource: '/api/su/salesReports',
      cacheKey: CacheKeys.SalesReportList(),
      callback: this.getSalesReportListCallback,
      ttlInSecs: 600,
    });
    cacheManager.getObject2(context);
  }

  getSalesReportListCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      salesReportList: response.salesReportList,
    });
  };

  onRefreshClick = () => {
    const { context } = this.props;
    CacheManager.removeObject(CacheKeys.SalesReportList());
    this.setState({
      errorList: null,
      salesReportList: null,
    });
    this.getSalesReportList(context);
  };
}

export default withRouter(SalesReportListPageSF);
